export default "__VITE_ASSET__63J4z63T__"